module.exports = __webpack_public_path__ + "static/img/RNI-Logo.8acfd86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/RNI-Logo.jpg
// module id = GoIj
// module chunks = 1